import { Card, CardContent, Skeleton, Stack } from "@mui/material";

const ChartSkeletonBar = ({ height = 250 }) => (
  <Card
    sx={{
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      border: "1px solid #e5e7eb",
    }}
  >
    <CardContent>
      <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
      <Stack direction="row" spacing={1} sx={{ alignItems: "end", height }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={40}
            height={Math.random() * height * 0.9 + 30}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Stack>
    </CardContent>
  </Card>
);

export default ChartSkeletonBar;
